import useURLSearchParams from "./useURLSearchParams";

function useSearchObject() {
	return Object.fromEntries(useURLSearchParams());
}

export default useSearchObject;
